module.exports = __webpack_public_path__ + "media/components/assets/icons/reply_skeleton-a5b747e01886901d48bfa2e56b379a52.svg";